import React from 'react'
import { connect } from 'react-redux'
import AdditionalDiamondPanel from './'
import JewelryPanel from '../jewelry-panel'
import * as actions from '../../../actions/jewelry-search'
import Button from '../../button'
import _ from 'lodash'
import PlusIcon from 'react-icons/lib/fa/plus'
import Spacer from '../../spacer'
import {
  showAdditionalDiamondPanel
} from '../../../utils/jewelry-validation'

const mapStateToProps = (state) => {
  return {
    ...state.jewelrySearch,
    additionalDiamonds: state.jewelrySearch.filters.additional_diamonds
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onClickAddAdditionalDiamond: () => {
      dispatch(actions.addAdditionalDiamond())
    },
    onClickRemoveAdditionalDiamond: (id) => {
      dispatch(actions.removeAdditionalDiamond(id))
    },
    onUpdateAdditionalDiamond: (id, field, value) => {
      dispatch(actions.updateAdditionalDiamond(id, field, value))
    },
    onSetAdditionalDiamondSizeOptions: (id, shape, quality) => {
      dispatch(actions.setAdditionalDiamondSizeOptions(id, shape, quality))
    }
  }
}

export const AdditionalDiamondContainer = props => {
  const additionalDiamondsContainer = () => {
    const additionalDiamonds = []
    _.keys(props.additionalDiamonds).forEach((key) => {
      const additionalDiamondProps = props.additionalDiamonds[key]
      additionalDiamonds.push(
        <AdditionalDiamondPanel
          {...additionalDiamondProps}
          key={key}
          jewelry_type={props.filters.jewelry_type}
          additionalDiamondId={key}
          onClickRemoveAdditionalDiamond={props.onClickRemoveAdditionalDiamond}
          onUpdateAdditionalDiamond={props.onUpdateAdditionalDiamond}
          onSetAdditionalDiamondSizeOptions={props.onSetAdditionalDiamondSizeOptions}
        />
      )
    })

    return additionalDiamonds
  }

  return (
    <div id='additional-diamonds-container'>
      <JewelryPanel
        id='additionalDiamondContainer'
        show={showAdditionalDiamondPanel(props.filters)}
        isResetting={props.isResetting}>

        <Spacer lg />

        {additionalDiamondsContainer()}

        <Button id={'add-additional-diamond-btn'} onClick={props.onClickAddAdditionalDiamond}>
          <PlusIcon /> Additional Diamond(s)
        </Button>

      </JewelryPanel>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalDiamondContainer)



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/additional-diamond-panel/additional-diamonds-container.js